import { FormItem } from '../../../../../../commons/Form/Form.types';
import { CompaniesDomainsFilterModalSchema } from './CompaniesDomainsFilterModal.types';
// import departments from '../../../../../../../assets/json/departements-domains.json';

export const companiesDomainsFilterData: FormItem<CompaniesDomainsFilterModalSchema>[][] =
  [
    [
      {
        name: 'domains',
        placeholder: "Domaine d'activité de la consultation...",
        label: "Domaine d'activité",
        type: 'select',
        id: 'domains',
      },
    ],
  ];
